import styled from '@emotion/styled';
import { QuestionCircleFilled } from '@ant-design/icons';

export const TooltipIcon = styled(QuestionCircleFilled)`
  color: ${props => props.theme.color.primary};
`;

export const DescriptionForLabel = styled.span`
  font-weight: ${props => props.theme.fontWeight.light};
  font-style: italic;
`;
